import { ref } from 'vue';

export const productInModalOpened = ref(false);
export const isProductWasOpened = ref(false);
